<template>
  <label
    class="inline-flex items-center cursor-pointer select-none leading-none"
    :class="{ 'cursor-not-allowed opacity-50': disabled }"
  >
    <input
      v-model="toggle"
      type="checkbox"
      class="hidden"
      :disabled="disabled"
    >
    <div
      class="inline-block relative rounded-full transition-all duration-300"
      :class="[
        { 'mr-10': label }, isBlue ? 'bg-link-color' : value ? 'bg-main-color' : 'bg-grey-700',
        isPlanToggle ? 'plan-toggle' : 'base-toggle'
      ]"
    />
    {{ label }}
  </label>
</template>

<script>
import { defineComponent, computed } from 'vue'
export default defineComponent({
  name: 'ToggleModule',

  /* PROPS */
  props: {
    label: { type: String, required: false },
    disabled: { type: Boolean, default: false },
    value: { type: Boolean, default: false },
    isBlue: { type: Boolean, default: false },
    isPlanToggle: { type: Boolean, default: false }
  },

  emits: ['input'],

  setup (props, { emit }) {
    const toggle = computed({
      get: () => props.value,
      set: (val) => {
        emit('input', val)
      }
    })

    return { toggle }
  }
})
</script>

<style lang="scss" scoped>
div.base-toggle {
  @apply w-27 h-15;
  &:after {
    content: '';
    @apply absolute top-2 right-14 w-11 h-11 bg-primary rounded-full transition-all duration-300;
  }
}

input:checked + div.base-toggle:after {
  @apply bg-primary right-2;
}

div.plan-toggle {
  @apply w-45 h-26;
  @screen md {
    @apply w-50;
  }
  &:after {
    content: '';
    @apply absolute right-24 top-6 w-14 h-14 bg-primary rounded-full transition-all duration-300;
    @screen md {
      @apply right-29;
    }
  }
}

input:checked + div.plan-toggle:after {
  @apply bg-primary right-7;
}
</style>
